import React from 'react';
import { View, StyleSheet, TouchableOpacity, Image } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import theme from '../../constants/theme.style.js';

const backButton = require('../../assets/icons/navigation/arrowBack.png');

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  body: {
    flex: 1,
    height: '100%',
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    paddingTop: 40,
    padding: theme.CONTAINER_MARGIN,
  },
  header: {
    marginTop: theme.CONTAINER_MARGIN * 1,
  },
  waveTop: {
    position: 'absolute',
    left: -50,
    bottom: 40,
    height: 150,
    width: '80%',
    maxWidth: 500,
  },
  headerText: {
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE * 3,
    fontFamily: 'Pacifico',
    marginTop: 10,
    padding: 20,
  },
  heading: {
    fontSize: theme.FONT_SIZE_TITLE,
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    color: theme.GREY_DARKER_COLOR,
    fontFamily: 'Nunito_ExtraBold',
  },
  subline: {
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    fontSize: theme.FONT_SIZE_HEADLINE,
    color: theme.GREY_DARKER_COLOR,
    paddingTop: 20,
    fontFamily: 'Nunito_ExtraBold',
  },
  text: {
    paddingTop: 5,
    fontSize: theme.FONT_SIZE_HEADLINE,
  },
  backButtonContainer: {
    width: 30,
    height: 20,
    marginLeft: 10,
    marginTop: 20,
  },
  centerWrap: {
    flex: 1,
    maxWidth: 900,
    width: '100%',
    alignSelf: 'center',
  },
});

// eslint-disable-next-line react/prefer-stateless-function
export default class ContactScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navigation: props.navigation,
    };
  }

  render() {
    const { navigation } = this.state;

    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.headerIconContainer}
            onPress={() => {
              navigation.goBack();
            }}
          >
            <Image style={styles.backButtonContainer} source={backButton} resizeMode="contain" />
          </TouchableOpacity>
          <View style={styles.centerWrap}>
            <CustomText style={styles.headerText}>Contact</CustomText>
          </View>
        </View>
        <View style={styles.body}>
          <View style={styles.centerWrap}>
            <CustomText style={styles.heading}>
              Having any questions regarding Turtlet? Get in touch!
            </CustomText>
            <CustomText style={styles.subline}>Address</CustomText>
            <CustomText style={styles.text}>Urstein Süd 1</CustomText>
            <CustomText style={styles.text}>A - 5412 Puch/Salzburg</CustomText>
            <CustomText style={styles.subline}>E-Mail</CustomText>
            <CustomText style={styles.text}>atischhart.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.text}>dbuder.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.text}>lseiwald.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.text}>szecha.mmt-m2019@fh-salzburg.ac.at</CustomText>
            <CustomText style={styles.subline}>Turtlet Account</CustomText>
            <CustomText style={styles.text}>Nickname: turtlev</CustomText>
            <CustomText style={styles.text}>
              You can also add us as a Friend and send us a Turtlet with your concern!
            </CustomText>
            <CustomText style={styles.text}>
              But be warned: the response may take a while. ;)
            </CustomText>
          </View>
        </View>
      </View>
    );
  }
}
